import { useState } from "react";
import { MainCard, MainCardTitle } from "src/components/main-card-type.tsx";
import { normalSanatizerBRL } from "src/utils/functions";
import { ResultCalculoINSS } from "../calcular-inss";
import { CalculadoraINSSTable } from "./CalculadoraINSSTable";

export const CalculadoraINSSResponse = ({
  results,
}: {
  results: ResultCalculoINSS;
}) => {
  const [showMethodology, setShowMethodology] = useState(false);
  const custoINSS = results;
  return (
    <MainCard className="mt-4">
      <MainCardTitle>Resultado</MainCardTitle>

      {/* Centraliza e mantém largura */}
      <div className="flex justify-center mb-2">
        <div className="w-full sm:w-1/2 lg:w-1/3 p-3 bg-primary rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center text-white font-semibold m-0">
            INSS Liquido
          </h2>
          <p className="sm:text-xl text-center font-bold text-md text-white m-0">
            <span className="text-sm mr-1 text-white">R$</span>
            {normalSanatizerBRL(results.ValorFinal)}
          </p>
        </div>
      </div>
      {/* Metodologia */}
      <div className="mb-6">
        <button
          onClick={() => setShowMethodology(!showMethodology)}
          className="w-full p-3 bg-blue-50 hover:bg-blue-100 rounded border border-blue-200 text-left transition-colors duration-200"
        >
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-blue-800 text-sm">
              Como Chegamos Nestes Valores
            </h3>
            <span className="text-blue-600 text-sm">
              {showMethodology ? "Ocultar" : "Ver Metodologia"}
            </span>
          </div>
        </button>

        {showMethodology && (
          <div className="mt-3 p-4 bg-blue-50 rounded border border-blue-200">
            <div className="grid sm:grid-cols-2 gap-4 text-xs">
              <div>
                <h4 className="font-semibold text-blue-800 mb-2">
                  Custo Mensal Real - Composição:
                </h4>
                <p className="text-blue-700 mb-1">
                  1. Salário bruto: R${" "}
                  {normalSanatizerBRL(custoINSS.ValorBruto)}
                </p>
                <p className="text-blue-700 mb-1">
                  2. Alíquota do INSS ({custoINSS.Aliquota}%):{" "}
                  {normalSanatizerBRL(custoINSS.ValorDescontado)}
                </p>
                <p className="text-blue-700 mb-1">
                  3. Salário Liquido R${" "}
                  {normalSanatizerBRL(custoINSS.ValorBruto)} - R${" "}
                  {normalSanatizerBRL(custoINSS.ValorDescontado)} = R${" "}
                  {normalSanatizerBRL(custoINSS.ValorFinal)}
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-blue-800 mb-2">
                  Cálculo Anual – Composição:
                </h4>
                <p className="text-blue-700 mb-1">
                  1. Salário bruto: R${" "}
                  {normalSanatizerBRL(custoINSS.ValorBruto)} X 12 = R${" "}
                  {normalSanatizerBRL(custoINSS.ValorBruto * 12)}
                </p>
                <p className="text-blue-700 mb-1">
                  2. Alíquota do INSS ({custoINSS.Aliquota}%) R${" "}
                  {normalSanatizerBRL(custoINSS.ValorDescontado)} X 12 = R${" "}
                  {normalSanatizerBRL(custoINSS.ValorDescontado * 12)}
                </p>
                <p className="text-blue-700 mb-1">
                  3. Salario Líquido Anual R${" "}
                  {normalSanatizerBRL(custoINSS.ValorBruto * 12)} - R${" "}
                  {normalSanatizerBRL(custoINSS.ValorDescontado * 12)} ={" "}
                  {normalSanatizerBRL(
                    custoINSS.ValorBruto * 12 - custoINSS.ValorDescontado * 12,
                  )}{" "}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      <CalculadoraINSSTable results={results} />
    </MainCard>
  );
};
